// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFormContent_root__1kqWb"};